import script from "./CInputCompetence.vue?vue&type=script&setup=true&lang=js"
export * from "./CInputCompetence.vue?vue&type=script&setup=true&lang=js"

import "./CInputCompetence.vue?vue&type=style&index=0&id=48be0cf6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48be0cf6"]])

export default __exports__